<mat-toolbar class="no-background">
  <span>振替依頼</span>
  <span class="spacer"></span>
  <mat-checkbox [(ngModel)]="showCompleted" (change)="onToggleCompleted()" style="margin-right: 32px;">
    完了・取消も表示する
  </mat-checkbox>
  <a mat-button class="add-link" routerLink="/transfer/create">
    <mat-icon>add</mat-icon>新しい振替依頼を作成
  </a>
  <a mat-button class="add-link" routerLink="/">
    <mat-icon>arrow_back</mat-icon>戻る
  </a>
</mat-toolbar>

<div style="margin-bottom: 12px;">
・各行をクリックすると、振替依頼の詳細画面に進みます。内容の確認・修正などにご利用ください。<br>
・手続きが完了した場合や、取り消す場合も、詳細画面で「完了」「取消」をクリックしてください。<br>
・事務処理の進捗状況によっては、修正・取消を承れない場合もございます。<br>
</div>

<div class="list-container">
  <ag-grid-angular
    class="ag-theme-alpine"
    style="width: 100%; height: calc(100vh - 350px);"
    [localeText]="localeText"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [pagination]="true"
    [paginationPageSize]="20"
    [paginationPageSizeSelector]="paginationPageSizeSelector"
    (rowClicked)="onRowClicked($event)">
  </ag-grid-angular>
</div>
